import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { capitalize } from '../../../utils/capitalize-string';
import { formatDate } from '../../../utils/format-date';
import styled, { css } from 'styled-components';
import { purpurColorRed600 } from '@purpurds/tokens/color/variables';
import spacing from 'theme/spacing';
import { pxToRem } from 'theme/utils';
export const StatusTimeWrapper = styled.div `
  display: flex;
  align-items: flex-end;
  flex-direction: column;
`;
const boldStatusStyles = css `
  max-width: ${pxToRem(140)};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;

  span.status {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
  }
`;
export const StatusRow = styled.span `
  ${({ $bold }) => $bold && boldStatusStyles};

  ${({ $isPastDue }) => $isPastDue &&
    css `
      color: ${purpurColorRed600};
    `};
`;
export const StatusText = styled.span `
  padding-left: ${spacing.spacing4};
`;
export const DateText = styled.span ``;
export const TimeText = styled.span `
  margin-top: ${spacing.spacing2};
`;
export const setStatusTimeDiv = (status, time, bold = false, date, isPastDue = false) => {
    const formattedDate = formatDate(date, 'short');
    return (_jsxs(StatusTimeWrapper, { children: [_jsxs(StatusRow, { "$bold": bold, "$isPastDue": isPastDue, children: [_jsx(DateText, { children: formattedDate }), _jsx(StatusText, { className: "status", children: capitalize(status) })] }), _jsx(TimeText, { children: time })] }));
};
